export enum AlertType {
  LowProfileCount = 'LowProfileCount',
  ProfileDeletedByUser = 'ProfileDeletedByUser',
  NoEsimAvailable = 'NoEsimAvailable',
}

export enum AlertStatus {
  Active = 'Active',
  Deprecated = 'Deprecated',
}

type ProfileDeletedByUserAlertPayload = {
  carrierId?: string;
  carrierName?: string;
};

type LowProfileCountAlertPayload = ProfileDeletedByUserAlertPayload;

type AlertSharedProps = {
  createdOn: string;
  status: AlertStatus;
  message?: string;
  customerName?: string;
};

export type AlertInfoDTO =
  | ({
      type: AlertType.ProfileDeletedByUser;
      payload?: ProfileDeletedByUserAlertPayload;
    } & AlertSharedProps)
  | ({
      type: AlertType.LowProfileCount;
      payload?: LowProfileCountAlertPayload;
    } & AlertSharedProps);
